export let appState: { [key: string]: any } = {};
